export default {
  favourites: [],
  favourite: undefined,
};
